<div class="loading-spinner-overlay" *ngIf="loading">
  <mat-spinner></mat-spinner>
</div>

<div>
  <div class="admin-access-denied" *ngIf="!user.isOwner">
    <h1>Access Denied</h1>
    <p>You do not have permission to view this page.</p>
  </div>

  <div class="admin-container" *ngIf="user.isOwner">
    <div *ngIf="adminLoadError" class="admin-error" style="margin-bottom:1rem; color:#b00020;">
      <strong>Failed to load admin list:</strong> {{ adminLoadError }}
      <button (click)="fetchAdmins()" style="margin-left:8px;">Retry</button>
      <span *ngIf="allAdmins.length" style="margin-left:8px; color:#444;">(showing cached/fallback data)</span>
    </div>
    <header class="admin-header">
      <h1>Admin Dashboard</h1>
      <p>Welcome, {{ user.displayName }}! Here you can manage users with Admin access.</p>

    </header>

    <!-- Compact toolbar for dialogs -->
    <div class="admin-dialog-launchers">
      <button type="button" class="launcher-btn" (click)="openOptionsDialog()">
        <mat-icon>tune</mat-icon><span>Manage Options</span>
      </button>
      <button type="button" class="launcher-btn" (click)="openHolidayDialog()">
        <mat-icon>event</mat-icon><span>Manage Holidays</span>
      </button>
      <button type="button" class="launcher-btn" (click)="openViewerDialog()">
        <mat-icon>visibility</mat-icon><span>Manage View Only Access</span>
      </button>
    </div>

    <section class="admin-search">
      <input type="text" [(ngModel)]="searchValue" placeholder="Search for a person by name"
        (keydown.enter)="search()" />
      <button *ngIf="!searching" (click)="search()">Search</button>
      <button *ngIf="searching">Searching...</button>
    </section>

  <section class="admin-search-results" *ngIf="searchResults.length > 0">
      <h2>Search Results</h2>
      <div class="person-list">
  <div class="person-card" *ngFor="let person of searchResults | slice:0:20; trackBy: trackPerson">
          <span class="person-info">
            {{ person.displayName }} ({{ person.jobTitle || 'No Title' }}) GMID: {{ person.onPremisesSamAccountName }}
          </span>
          <button *ngIf="addingGmid !== person.onPremisesSamAccountName" class="add-button" (click)="addAdmin(person)">
            Add Admin
          </button>
          <button *ngIf="addingGmid === person.onPremisesSamAccountName" class="add-button" disabled>
            Adding...
          </button>
        </div>
      </div>
    </section>

  <section class="admin-list">
      <h2>All Admins</h2>
      <div class="admin-list-cards">
        <div class="admin-card" *ngFor="let admin of allAdmins; trackBy: trackAdmin">
          <div class="admin-main-info">
            <span class="admin-info">{{ admin.displayName || admin.name }} ({{ admin.gmid }}) {{ admin.email }}</span>

            <!-- Scheduling Team Checkbox -->
            <div class="scheduling-team-container">
              <mat-checkbox [checked]="admin.isSchedulingTeam" [disabled]="updatingSchedulingTeam === admin.gmid"
                (change)="updateSchedulingTeam(admin, $event.checked)">
                Scheduling Team
              </mat-checkbox>
            </div>

            <!-- Owner Checkbox -->
            <div class="owner-container">
              <mat-checkbox [checked]="admin.isOwner" [disabled]="updatingOwner === admin.gmid"
                (change)="updateOwnerStatus(admin, $event.checked)">
                Owner
              </mat-checkbox>
            </div>

            <!-- Color Management Section -->
            <div class="color-management" *ngIf="editingColorGmid === admin.gmid">
              <div class="color-input-section">
                <!-- Color Wheel/Picker -->
                <input
                  type="color"
                  [(ngModel)]="colorInputs[admin.gmid]"
                  class="color-picker"
                  (change)="onColorPickerChange(admin.gmid, $event)"
                  title="Click to open color picker"
                />

                <!-- Hex Input -->
                <input
                  type="text"
                  [(ngModel)]="colorInputs[admin.gmid]"
                  placeholder="#FF0000"
                  class="color-input"
                  maxlength="7"
                  (input)="onHexInputChange(admin.gmid, $event)"
                />
              </div>
              <div class="color-actions">
                <button class="save-color-button" (click)="updateUserColor(admin.gmid)">Save Color</button>
                <button class="cancel-color-button" (click)="cancelColorEdit()">Cancel</button>
              </div>
            </div>

            <!-- Current color display when not editing -->
            <div class="current-color-display" *ngIf="editingColorGmid !== admin.gmid">
              <span class="color-label">Current Color:</span>
              <div class="color-preview" [style.background-color]="getCurrentSavedColor(admin.gmid)">
              </div>
              <span class="color-value">{{ getCurrentSavedColor(admin.gmid) || '(none)' }}</span>
              <span *ngIf="isColorUnsynced(admin.gmid)" class="unsynced-indicator">(local only)</span>
            </div>
          </div>

          <div class="admin-actions">
            <button *ngIf="editingColorGmid !== admin.gmid" class="edit-color-button"
              (click)="initColorInput(admin.gmid)">
              Edit Color
            </button>
            <button *ngIf="removingGmid !== admin.gmid && editingColorGmid !== admin.gmid" class="remove-button"
              (click)="removeAdmin(admin.gmid)">
              Remove Admin
            </button>
            <button *ngIf="removingGmid === admin.gmid" class="remove-button" disabled>
              Removing...
            </button>
          </div>
        </div>
      </div>
    </section>
    

    <!-- Dialog Templates moved outside conditional sections to ensure availability -->
    <!-- Options Dialog Template -->
    <ng-template #optionsDialogTemplate>
      <div class="dialog-wrapper options-dialog modern-options">
        <div class="section-header">
          <div>
            <h2>Manage Options</h2>
            <p class="subhead">Configure the selectable lists & key/value sets used across events.</p>
          </div>
          <div class="option-selection">
            <mat-form-field appearance="outline" class="option-select-field">
              <mat-label>Select Option Set</mat-label>
              <mat-select [(value)]="selectedOptionName" (selectionChange)="onOptionSelected($event.value)">
                <mat-option *ngFor="let optionName of optionNames" [value]="optionName">{{ optionName }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="dialog-scroll-area scroll-hide" (scroll)="onDialogScroll($event)" [ngClass]="{ 'shadow-top': dialogScrollTopActive, 'shadow-bottom': dialogScrollBottomActive }">
          <div class="option-card" *ngIf="selectedOptionDetails">
            <div class="option-card-header">
              <h3>{{ selectedOptionDetails.name }}</h3>
              <!-- <span class="badge" [ngClass]="{ 'badge-object': selectedOptionDetails.isObject, 'badge-list': !selectedOptionDetails.isObject }">
                {{ selectedOptionDetails.isObject ? 'Object Set' : 'List Set' }}
              </span> -->
            </div>
            <div class="option-card-body">
              <!-- Top Add Option Inline -->
              <div class="add-option-inline top">
                <mat-form-field appearance="outline" class="add-field">
                  <mat-label>New Value</mat-label>
                  <input matInput [(ngModel)]="newOptionValue" (keydown.enter)="!addingNewOption && newOptionValue && addNewOption()" placeholder="Add option" />
                </mat-form-field>
                <button class="add-icon-btn" [disabled]="!newOptionValue || addingNewOption" (click)="addNewOption()" aria-label="Add option">
                  <mat-icon *ngIf="!addingNewOption">add</mat-icon>
                  <span *ngIf="addingNewOption" class="loading-text">...</span>
                </button>
              </div>
              <div class="current-options-block">
                <h4 class="block-title">Current Values</h4>
                <div *ngIf="selectedOptionDetails.isObject" class="option-list">
                  <div class="option-row" *ngFor="let key of getOptionKeys()">
                    <div class="value-wrapper"><span class="value-label">{{ getParsedOptions()[key] }}</span></div>
                    <div class="item-actions">
                      <button class="icon-btn danger" aria-label="Remove option" [disabled]="removingOptionKey === key" (click)="removeOption(key)">
                        <mat-icon *ngIf="removingOptionKey !== key">delete</mat-icon>
                        <span *ngIf="removingOptionKey === key" class="loading-text">...</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div *ngIf="!selectedOptionDetails.isObject" class="option-list">
                  <div class="option-row" *ngFor="let val of selectedOptionDetails.value">
                    <div class="value-wrapper"><span class="value-label">{{ val }}</span></div>
                    <div class="item-actions">
                      <button class="icon-btn danger" aria-label="Remove option" [disabled]="removingOptionKey === val" (click)="removeOption(val)">
                        <mat-icon *ngIf="removingOptionKey !== val">delete</mat-icon>
                        <span *ngIf="removingOptionKey === val" class="loading-text">...</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Calendar Viewer Dialog Template -->
    <ng-template #viewerDialogTemplate>
      <div class="dialog-wrapper modern-dialog viewer-dialog">
        <div class="section-header">
          <div>
            <h2>Calendar Viewers</h2>
            <p class="subhead">Grant or revoke read-only access to the event calendar.</p>
          </div>
        </div>
        <div class="dialog-scroll-area scroll-hide" (scroll)="onDialogScroll($event)" [ngClass]="{ 'shadow-top': dialogScrollTopActive, 'shadow-bottom': dialogScrollBottomActive }">
          <div class="dialog-card viewer-card">
            <div class="dialog-note">
                View only Access, will not get system emails
            </div>
            <div class="viewer-search-block">
              <mat-form-field appearance="outline" class="viewer-search-field">
                <mat-label>Search for a person by name</mat-label>
                <input matInput [(ngModel)]="searchName" (keydown.enter)="searchForPerson()" placeholder="Type a name and press Enter">
                <button mat-icon-button matSuffix (click)="searchForPerson()" [disabled]="!searchName || searchingForPersonLoading">
                  <mat-icon *ngIf="!searchingForPersonLoading">search</mat-icon>
                  <mat-spinner *ngIf="searchingForPersonLoading" diameter="20"></mat-spinner>
                </button>
              </mat-form-field>
            </div>
            <div class="viewer-table">
              <div class="viewer-row header">
                <div>Name</div>
                <div>Email</div>
                <div class="actions">Remove</div>
              </div>
              <div *ngIf="!viewers?.length" class="empty-state">
                <p>No viewers currently have access.</p>
              </div>
              @for (v of viewers; let i = $index; track viewers) {
                <div class="viewer-row">
                  @if (v.gmid && v.gmid !== '') {
                    <div>
                      {{ viewers[i].name }}
                    </div>
                    <div>
                      {{ viewers[i].email }}
                    </div>
                    <div class="actions">
                      <button mat-icon-button color="warn" (click)="removeViewer(i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Holiday Dialog Template -->
    <ng-template #holidayDialogTemplate>
      <div class="dialog-wrapper modern-dialog holiday-dialog">
        <div class="section-header">
          <div>
            <h2>GM Holidays</h2>
            <p class="subhead">Manage official GM holiday dates. Future &amp; current year only.</p>
          </div>
        </div>
        <div class="dialog-scroll-area scroll-hide" (scroll)="onDialogScroll($event)" [ngClass]="{ 'shadow-top': dialogScrollTopActive, 'shadow-bottom': dialogScrollBottomActive }">
          <div class="dialog-card holiday-dialog-card">
            <div class="dialog-note"><small>Select a date then click plus. Saved rows can be deleted.</small></div>
            <div class="holiday-grid">
              <!-- Top add holiday inline -->
              <div class="holiday-add-inline">
                <mat-form-field appearance="outline" class="date-field top-add">
                  <mat-label>New Holiday Date</mat-label>
                  <input matInput [matDatepicker]="newHolidayPicker" [(ngModel)]="newHolidayDate" name="newHolidayDate" />
                  <mat-datepicker-toggle matSuffix [for]="newHolidayPicker"></mat-datepicker-toggle>
                  <mat-datepicker #newHolidayPicker></mat-datepicker>
                </mat-form-field>
                <button class="add-icon-btn" aria-label="Add holiday" [disabled]="!newHolidayDate || addingHoliday" (click)="addHolidayTop()">
                  <mat-icon *ngIf="!addingHoliday">add</mat-icon>
                  <span *ngIf="addingHoliday" class="loading-text">...</span>
                </button>
              </div>
              <!-- Existing holidays list -->
              @for (holiday of holidays; let i = $index; track holiday) {
                @if (holiday.id) {
                  <div class="holiday-row">
                    <mat-form-field appearance="outline" class="date-field">
                      <mat-label>Holiday Date</mat-label>
                      <input matInput [matDatepicker]="holidayPicker" [(ngModel)]="holidays[i].date" name="holidayDlg{{i}}" />
                      <mat-datepicker-toggle matSuffix [for]="holidayPicker"></mat-datepicker-toggle>
                      <mat-datepicker #holidayPicker></mat-datepicker>
                    </mat-form-field>
                    <div class="actions">
                      <button class="icon-btn danger" aria-label="Remove holiday" (click)="removeHoliday(i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>

